export enum SubscriptionStatus {
    Inactive = 0,
    Active = 1,
    Cancelled = 2,
    Pending = 3,
    Enterprise = 4,
}

export enum SubscriptionType {
    Downgrade = 'downgrade',
}

export enum PaymentFrequency {
    Annual = 'annual',
    Monthly = 'monthly',
}
export interface ISubscriptionPayload {
    id: string;
    status: SubscriptionStatus;
    type: SubscriptionType;
    amount: number;
    baseAmount: number;
    paymentFrequency: PaymentFrequency;
    nextPaymentDate: string;
    createdAt: string;
}

export class Subscription {
    private readonly _id: string;
    private readonly _status: SubscriptionStatus;
    private readonly _type: SubscriptionType;
    private readonly _amount: number;
    private readonly _baseAmount: number;
    private readonly _paymentFrequency: PaymentFrequency;
    private readonly _nextPaymentDate: string;
    private readonly _createdAt: string;

    constructor(subscriptionPayload: ISubscriptionPayload) {
        this._id = subscriptionPayload.id;
        this._status = subscriptionPayload.status;
        this._type = subscriptionPayload.type;
        this._amount = subscriptionPayload.amount;
        this._baseAmount = subscriptionPayload.baseAmount;
        this._paymentFrequency = subscriptionPayload.paymentFrequency;
        this._nextPaymentDate = subscriptionPayload.nextPaymentDate;
        this._createdAt = subscriptionPayload.createdAt;
    }

    public get id(): string {
        return this._id;
    }

    public get status(): SubscriptionStatus {
        return this._status;
    }

    public get type(): SubscriptionType {
        return this._type;
    }

    public get amount(): number {
        return this._amount;
    }

    public get baseAmount(): number {
        return this._baseAmount;
    }

    public get paymentFrequency(): PaymentFrequency {
        return this._paymentFrequency;
    }

    public get nextPaymentDate(): string {
        return this._nextPaymentDate;
    }

    public get createdAt(): string {
        return this._createdAt;
    }
}
